import { Tag } from "lucide-react";

import { createNavigationLucideIcon } from "./createNavigationLucideIcon";

export const ProductsIcon = createNavigationLucideIcon(Tag);
